import { LogLevel, type LogLevelConfig } from '@simplisafe/compass-web'
import { LoggerName } from './LoggerName'

/**
 * Log levels used in production. defaultLevel INFO captures info/warn/error while dropping the
 * noisier trace/debug output. Individual named loggers can be raised or lowered here, and can also
 * be overridden at runtime per logger via localStorage.
 */
export const prodLogLevels: LogLevelConfig<typeof LoggerName> = {
  defaultLevel: LogLevel.INFO,
  namedLoggers: {}
}
